require('./dist/select.js');
module.exports = 'ui.select';



// WEBPACK FOOTER //
// ./~/ui-select/index.js